module.exports = __webpack_public_path__ + "static/media/rwa_bg.c93aa866.png";